import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getClientRefillHistory: async({ commit, dispatch }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            responseType: params.excel ? 'blob' : 'json',
            url: 'client/refill/history',
            params
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total
                })
                commit('SET_REFILL_HISTORY', res.data.items)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    }
}
